export enum AppointmentStatus {
  CONFIRMED = "confirmado",
  PENDING = "pendente",
  CANCELLED = "cancelado"
}

export enum SessionType {
  CONSTELACAO = "Constelação",
  PARTICIPACAO = "Participação"
}
